/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.1.0
 */

import { FreshAsphalt, FreshAsphalt50, SpbSky0, SpbSky1 } from './palette';

/*
* -------------------------------------------
*            ACCOUNT CONTROLLER
* -------------------------------------------
*/

export const expensesAnalyzerAccountControllerBgColor = SpbSky0;
export const expensesAnalyzerAccountControllerBorderColor = SpbSky1;
export const expensesAnalyzerTextColor = FreshAsphalt;
export const expensesAnalyzerTextColorSecondary = FreshAsphalt50;
